import { makeStyles } from "tss-react/mui";

export const useBannerStyles = makeStyles()({
  closeButtonPosition: {
    position: "relative",
    top: -16,
    right: 0,
  },
  colorWhite: {
    color: "white",
  },
});
